import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type StatusRiscoComprovacao = 'critico' | 'atencao' | 'saudavel';

export interface ComprovacaoContratoResumo {
  contrato_id: string;
  total_boletins: number;
  criticos: number;
  em_atraso: number;
  total_em_atraso: number;
  pior_atraso_dias: number;
  status_risco: StatusRiscoComprovacao;
}

/**
 * Hook que retorna um mapa { contrato_id -> resumo de comprovação }
 * para uso em listagens de contratos. Fonte única: vw_net_comprovacao_contrato.
 */
export function useComprovacaoContratoMap(contratoIds: string[]) {
  return useQuery({
    queryKey: ['net-comprovacao-contrato-map', ...contratoIds.sort()],
    queryFn: async () => {
      if (contratoIds.length === 0) return {} as Record<string, ComprovacaoContratoResumo>;
      const { data, error } = await supabase
        .from('vw_net_comprovacao_contrato' as any)
        .select('*')
        .in('contrato_id', contratoIds);
      if (error) {
        console.error('[useComprovacaoContratoMap]', error);
        return {} as Record<string, ComprovacaoContratoResumo>;
      }
      const map: Record<string, ComprovacaoContratoResumo> = {};
      for (const row of (data || []) as any[]) {
        map[row.contrato_id] = row as ComprovacaoContratoResumo;
      }
      return map;
    },
    enabled: contratoIds.length > 0,
    staleTime: 60 * 1000,
  });
}
